import React from "react";

const Header = ({ title, subTitle }) => {
  const headingStyle = {
    textAlign: "center",
    marginTop: "30px",
    marginBottom: "30px",
    position: "relative",
    overflow: "hidden",
  };
  const titleStyle = {
    border: "2px solid #007BFF",
    borderRadius: "4px",
    padding: "10px",
    backgroundColor: "#007BFF",
    color: "white",
    fontSize: "28px", // Increase the font size for the title
  };

  const subTitleStyle = {
    fontSize: "20px", // Increase the font size for the subheading
    color: "#020202",
    fontWeight: "bold",
    letterSpacing: "2px",
  };

  const etaxiStyle = {
    fontFamily: "Roboto, sans-serif", // Use a more modern font
  };

  return (
    <div style={headingStyle}>
      <img
        src="/img11.jpg"
        alt="Watermark"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "420px",
          maxWidth: "90%",
          height: "auto",
          opacity: 0.06,
          pointerEvents: "none",
          userSelect: "none",
          objectFit: "contain",
          filter: "grayscale(100%)",
        }}
      />
      <h1 style={titleStyle}>{title}</h1>
      {subTitle ? (
        <p style={subTitleStyle}>
          {subTitle} <span style={etaxiStyle} />
        </p>
      ) : null}
    </div>
  );
};

export default Header;
